import { render, staticRenderFns } from "./SuccessLoginTemplate.vue?vue&type=template&id=a31a889e&"
import script from "./SuccessLoginTemplate.vue?vue&type=script&lang=js&"
export * from "./SuccessLoginTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports